"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbilityType = void 0;
var AbilityType;
(function (AbilityType) {
    AbilityType[AbilityType["ArcaneBarrage"] = 1] = "ArcaneBarrage";
    AbilityType[AbilityType["LikeABoss"] = 2] = "LikeABoss";
    // Warrior
    AbilityType[AbilityType["Chop"] = 100] = "Chop";
    AbilityType[AbilityType["Cyclone"] = 101] = "Cyclone";
    AbilityType[AbilityType["Eviscerate"] = 102] = "Eviscerate";
    AbilityType[AbilityType["AxeThrow"] = 103] = "AxeThrow";
    AbilityType[AbilityType["Whirlwind"] = 104] = "Whirlwind";
    AbilityType[AbilityType["Painkiller"] = 105] = "Painkiller";
    AbilityType[AbilityType["Overload"] = 106] = "Overload";
    AbilityType[AbilityType["Bodyguard"] = 107] = "Bodyguard";
    AbilityType[AbilityType["RapidStrikes"] = 108] = "RapidStrikes";
    AbilityType[AbilityType["NjordsWarcry"] = 109] = "NjordsWarcry";
    AbilityType[AbilityType["BamsBouncingThunderclap"] = 110] = "BamsBouncingThunderclap";
    // Vampire
    AbilityType[AbilityType["Slice"] = 200] = "Slice";
    AbilityType[AbilityType["BloodPact"] = 201] = "BloodPact";
    AbilityType[AbilityType["SigilOfBlood"] = 202] = "SigilOfBlood";
    AbilityType[AbilityType["EmiliasKissOfSorrow"] = 203] = "EmiliasKissOfSorrow";
    AbilityType[AbilityType["MidnightsGaze"] = 204] = "MidnightsGaze";
    AbilityType[AbilityType["SigilOfDamnation"] = 205] = "SigilOfDamnation";
    AbilityType[AbilityType["FrejasEpidemic"] = 206] = "FrejasEpidemic";
    AbilityType[AbilityType["VisionOfKatajen"] = 207] = "VisionOfKatajen";
    AbilityType[AbilityType["HammeringOfDmina"] = 208] = "HammeringOfDmina";
    AbilityType[AbilityType["SigilOfTheDamken"] = 209] = "SigilOfTheDamken";
    AbilityType[AbilityType["AugurysFinalOmen"] = 210] = "AugurysFinalOmen";
    // Valkyrie
    AbilityType[AbilityType["Arc"] = 300] = "Arc";
    AbilityType[AbilityType["WingBuffett"] = 301] = "WingBuffett";
    AbilityType[AbilityType["Shatter"] = 302] = "Shatter";
    AbilityType[AbilityType["TemporalShift"] = 303] = "TemporalShift";
    AbilityType[AbilityType["ShieldOfKatalina"] = 304] = "ShieldOfKatalina";
    AbilityType[AbilityType["FlamesOfTobias"] = 305] = "FlamesOfTobias";
    AbilityType[AbilityType["ObidiahsBurningIncantation"] = 306] = "ObidiahsBurningIncantation";
    AbilityType[AbilityType["ReflectionOfTessalyn"] = 307] = "ReflectionOfTessalyn";
    AbilityType[AbilityType["BurningOfCyrus"] = 308] = "BurningOfCyrus";
    AbilityType[AbilityType["DarkCarnival"] = 309] = "DarkCarnival";
    AbilityType[AbilityType["FlamesOfWar"] = 310] = "FlamesOfWar";
    // High Priestess
    AbilityType[AbilityType["Blast"] = 400] = "Blast";
    AbilityType[AbilityType["Heal"] = 401] = "Heal";
    AbilityType[AbilityType["Regeneration"] = 402] = "Regeneration";
    AbilityType[AbilityType["Resurrection"] = 403] = "Resurrection";
    AbilityType[AbilityType["AeridynesSpring"] = 404] = "AeridynesSpring";
    AbilityType[AbilityType["SorisHug"] = 405] = "SorisHug";
    AbilityType[AbilityType["BlessingOfAlaresa"] = 406] = "BlessingOfAlaresa";
    AbilityType[AbilityType["TessasAscension"] = 407] = "TessasAscension";
    AbilityType[AbilityType["WhispersOfTheAncientOne"] = 408] = "WhispersOfTheAncientOne";
    AbilityType[AbilityType["ShieldOfSylvie"] = 409] = "ShieldOfSylvie";
    AbilityType[AbilityType["NorisSacrifice"] = 410] = "NorisSacrifice";
    AbilityType[AbilityType["Sanctuary"] = 411] = "Sanctuary";
    AbilityType[AbilityType["DivineResolution"] = 412] = "DivineResolution";
    // Augur
    AbilityType[AbilityType["Zap"] = 500] = "Zap";
    AbilityType[AbilityType["Omen"] = 501] = "Omen";
    AbilityType[AbilityType["SignaExCoelo"] = 502] = "SignaExCoelo";
    AbilityType[AbilityType["Terror"] = 503] = "Terror";
    AbilityType[AbilityType["Possess"] = 504] = "Possess";
    AbilityType[AbilityType["ConsumeSouls"] = 505] = "ConsumeSouls";
    AbilityType[AbilityType["Transference"] = 506] = "Transference";
    AbilityType[AbilityType["Hoodoo"] = 507] = "Hoodoo";
    AbilityType[AbilityType["HexOfXiia"] = 508] = "HexOfXiia";
    AbilityType[AbilityType["NorthsInfinitum"] = 509] = "NorthsInfinitum";
    AbilityType[AbilityType["RavensCall"] = 510] = "RavensCall";
    AbilityType[AbilityType["SignaExDiris"] = 511] = "SignaExDiris";
    // Assassin
    AbilityType[AbilityType["Cut"] = 600] = "Cut";
    AbilityType[AbilityType["PoisonedBlades"] = 601] = "PoisonedBlades";
    AbilityType[AbilityType["MarkOfTheKunir"] = 602] = "MarkOfTheKunir";
    AbilityType[AbilityType["ContaminationOfRo"] = 603] = "ContaminationOfRo";
    AbilityType[AbilityType["IntoTheShadows"] = 604] = "IntoTheShadows";
    AbilityType[AbilityType["Strangle"] = 605] = "Strangle";
    AbilityType[AbilityType["Mince"] = 606] = "Mince";
    AbilityType[AbilityType["Bombardment"] = 607] = "Bombardment";
    AbilityType[AbilityType["Lacerate"] = 608] = "Lacerate";
    AbilityType[AbilityType["Bandage"] = 609] = "Bandage";
    AbilityType[AbilityType["Assassinate"] = 610] = "Assassinate";
    AbilityType[AbilityType["MasterOfPoisons"] = 611] = "MasterOfPoisons";
    // Avenger
    AbilityType[AbilityType["AvengingSlash"] = 700] = "AvengingSlash";
    AbilityType[AbilityType["ShieldBash"] = 701] = "ShieldBash";
    AbilityType[AbilityType["Onslaught"] = 702] = "Onslaught";
    AbilityType[AbilityType["RosFortress"] = 703] = "RosFortress";
    AbilityType[AbilityType["DoubleAttack"] = 704] = "DoubleAttack";
    AbilityType[AbilityType["Vengeance"] = 705] = "Vengeance";
    AbilityType[AbilityType["RyversTouch"] = 706] = "RyversTouch";
    AbilityType[AbilityType["TheBlockade"] = 707] = "TheBlockade";
    AbilityType[AbilityType["Revenge"] = 708] = "Revenge";
    AbilityType[AbilityType["TripleAttack"] = 709] = "TripleAttack";
    AbilityType[AbilityType["RighteousFury"] = 710] = "RighteousFury";
    AbilityType[AbilityType["Apocalypse"] = 711] = "Apocalypse";
    // The Tribunal
    AbilityType[AbilityType["Subjugate"] = 800] = "Subjugate";
    AbilityType[AbilityType["RegenerativeLoop"] = 801] = "RegenerativeLoop";
    AbilityType[AbilityType["Erasure"] = 802] = "Erasure";
    AbilityType[AbilityType["Collapse"] = 803] = "Collapse";
    AbilityType[AbilityType["GravityFlux"] = 804] = "GravityFlux";
    AbilityType[AbilityType["PowerApex"] = 805] = "PowerApex";
    AbilityType[AbilityType["TelestriasStarfall"] = 806] = "TelestriasStarfall";
    AbilityType[AbilityType["AlissasLink"] = 807] = "AlissasLink";
    AbilityType[AbilityType["MagsParadox"] = 808] = "MagsParadox";
    AbilityType[AbilityType["TelekineticForceWave"] = 809] = "TelekineticForceWave";
    AbilityType[AbilityType["XyriasPardon"] = 810] = "XyriasPardon";
    // Tempest
    AbilityType[AbilityType["FrostAndFireBolt"] = 900] = "FrostAndFireBolt";
    AbilityType[AbilityType["ElementalShield"] = 901] = "ElementalShield";
    AbilityType[AbilityType["LightningBolt"] = 902] = "LightningBolt";
    AbilityType[AbilityType["MeteorStorm"] = 903] = "MeteorStorm";
    AbilityType[AbilityType["Stormstrike"] = 904] = "Stormstrike";
    AbilityType[AbilityType["PermafrostVortex"] = 905] = "PermafrostVortex";
    AbilityType[AbilityType["ArconBarrier"] = 906] = "ArconBarrier";
    AbilityType[AbilityType["Mirror"] = 907] = "Mirror";
    AbilityType[AbilityType["Inferno"] = 908] = "Inferno";
    AbilityType[AbilityType["Disintegrate"] = 909] = "Disintegrate";
    AbilityType[AbilityType["KatjasHourglass"] = 910] = "KatjasHourglass";
    // Executioner
    AbilityType[AbilityType["Carve"] = 1000] = "Carve";
    AbilityType[AbilityType["Impale"] = 1001] = "Impale";
    AbilityType[AbilityType["CommandingPresence"] = 1002] = "CommandingPresence";
    AbilityType[AbilityType["PowerAmplification"] = 1003] = "PowerAmplification";
    AbilityType[AbilityType["Pardon"] = 1004] = "Pardon";
    AbilityType[AbilityType["Indictment"] = 1005] = "Indictment";
    AbilityType[AbilityType["OffWithTheirHead"] = 1006] = "OffWithTheirHead";
    AbilityType[AbilityType["EternalPunishment"] = 1007] = "EternalPunishment";
    AbilityType[AbilityType["Berserk"] = 1008] = "Berserk";
    AbilityType[AbilityType["Execute"] = 1009] = "Execute";
    AbilityType[AbilityType["DramaticEndings"] = 1010] = "DramaticEndings";
    // Ranger
    AbilityType[AbilityType["PiercingShot"] = 1100] = "PiercingShot";
    AbilityType[AbilityType["Barrage"] = 1101] = "Barrage";
    AbilityType[AbilityType["ArcaneShot"] = 1102] = "ArcaneShot";
    AbilityType[AbilityType["TheSupremeHunt"] = 1103] = "TheSupremeHunt";
    AbilityType[AbilityType["MarkOfThePredator"] = 1104] = "MarkOfThePredator";
    AbilityType[AbilityType["ResurrectPet"] = 1105] = "ResurrectPet";
    AbilityType[AbilityType["HealPet"] = 1106] = "HealPet";
    AbilityType[AbilityType["Redirection"] = 1107] = "Redirection";
    AbilityType[AbilityType["MurderedByCrows"] = 1108] = "MurderedByCrows";
    AbilityType[AbilityType["Overkill"] = 1109] = "Overkill";
    AbilityType[AbilityType["KillShot"] = 1110] = "KillShot";
    AbilityType[AbilityType["CallOfTheWild"] = 1111] = "CallOfTheWild";
    AbilityType[AbilityType["CautiousAim"] = 1112] = "CautiousAim";
    AbilityType[AbilityType["KillingMachine"] = 1113] = "KillingMachine";
    AbilityType[AbilityType["MasterSharpshooter"] = 1114] = "MasterSharpshooter";
    // Hamm
    AbilityType[AbilityType["IntimidationOfTheKing"] = 1200] = "IntimidationOfTheKing";
    AbilityType[AbilityType["WatchThemDie"] = 1201] = "WatchThemDie";
    AbilityType[AbilityType["Enrage"] = 1202] = "Enrage";
    AbilityType[AbilityType["TheKingsWardrobe"] = 1203] = "TheKingsWardrobe";
    AbilityType[AbilityType["Smite"] = 1204] = "Smite";
    AbilityType[AbilityType["SecondStrike"] = 1205] = "SecondStrike";
    AbilityType[AbilityType["RiotBreaker"] = 1206] = "RiotBreaker";
    // Ravyn, The Damned
    AbilityType[AbilityType["BloodyAura"] = 1300] = "BloodyAura";
    AbilityType[AbilityType["GrimdinesCurse"] = 1301] = "GrimdinesCurse";
    AbilityType[AbilityType["ScreamOfXira"] = 1302] = "ScreamOfXira";
    AbilityType[AbilityType["BloodSacrifice"] = 1303] = "BloodSacrifice";
    AbilityType[AbilityType["RavynsSlash"] = 1304] = "RavynsSlash";
    // Xyria
    AbilityType[AbilityType["XyriasLink"] = 1400] = "XyriasLink";
    AbilityType[AbilityType["ShroudOfImmortality"] = 1401] = "ShroudOfImmortality";
    AbilityType[AbilityType["AuraOfTheConqueror"] = 1402] = "AuraOfTheConqueror";
    AbilityType[AbilityType["CrushingBlow"] = 1403] = "CrushingBlow";
    AbilityType[AbilityType["XyriasRegenerativeLoop"] = 1404] = "XyriasRegenerativeLoop";
    AbilityType[AbilityType["Eternity"] = 1405] = "Eternity";
    AbilityType[AbilityType["TheDeathDoctrine"] = 1406] = "TheDeathDoctrine";
    // Lady Nyx
    AbilityType[AbilityType["Firestorm"] = 1500] = "Firestorm";
    AbilityType[AbilityType["MoarWhelps"] = 1501] = "MoarWhelps";
    AbilityType[AbilityType["Meltdown"] = 1502] = "Meltdown";
    AbilityType[AbilityType["Pyroblast"] = 1503] = "Pyroblast";
    AbilityType[AbilityType["BurningDesire"] = 1504] = "BurningDesire";
    AbilityType[AbilityType["DragonsBreath"] = 1505] = "DragonsBreath";
    // Dragon Whelp
    AbilityType[AbilityType["TailSwipe"] = 1600] = "TailSwipe";
    // Caedecus of the Arcane
    AbilityType[AbilityType["BeNoMore"] = 1700] = "BeNoMore";
    AbilityType[AbilityType["CaedecusArcaneBarrage"] = 1701] = "CaedecusArcaneBarrage";
    AbilityType[AbilityType["CaedecusArcaneBlast"] = 1702] = "CaedecusArcaneBlast";
    AbilityType[AbilityType["CosmicSmash"] = 1703] = "CosmicSmash";
    AbilityType[AbilityType["OutOfTime"] = 1704] = "OutOfTime";
    AbilityType[AbilityType["GazeOfPetrification"] = 1705] = "GazeOfPetrification";
    // Gladiator
    AbilityType[AbilityType["GladiatorsStrike"] = 1800] = "GladiatorsStrike";
    AbilityType[AbilityType["TripleSlash"] = 1801] = "TripleSlash";
    AbilityType[AbilityType["Counter"] = 1802] = "Counter";
    AbilityType[AbilityType["GladiatorsParry"] = 1803] = "GladiatorsParry";
    AbilityType[AbilityType["Burst"] = 1804] = "Burst";
    AbilityType[AbilityType["InfinityStrike"] = 1805] = "InfinityStrike";
    AbilityType[AbilityType["Disorder"] = 1806] = "Disorder";
    AbilityType[AbilityType["Bloodthirsty"] = 1807] = "Bloodthirsty";
    AbilityType[AbilityType["GladiatorsBandage"] = 1808] = "GladiatorsBandage";
    AbilityType[AbilityType["IndestructibleBattleCry"] = 1809] = "IndestructibleBattleCry";
    AbilityType[AbilityType["Fragment"] = 1810] = "Fragment";
    AbilityType[AbilityType["RegenerativeBattleCry"] = 1811] = "RegenerativeBattleCry";
    AbilityType[AbilityType["Disembowel"] = 1812] = "Disembowel";
    // Monk
    AbilityType[AbilityType["StickEm"] = 1900] = "StickEm";
    AbilityType[AbilityType["KegToss"] = 1901] = "KegToss";
    AbilityType[AbilityType["Whop"] = 1902] = "Whop";
    AbilityType[AbilityType["GroupMeditation"] = 1903] = "GroupMeditation";
    AbilityType[AbilityType["Maul"] = 1904] = "Maul";
    AbilityType[AbilityType["Flurry"] = 1905] = "Flurry";
    AbilityType[AbilityType["ImpenetrableDefense"] = 1906] = "ImpenetrableDefense";
    AbilityType[AbilityType["DrunkenClarity"] = 1907] = "DrunkenClarity";
    AbilityType[AbilityType["OleShakyStick"] = 1908] = "OleShakyStick";
    AbilityType[AbilityType["DeferDeath"] = 1909] = "DeferDeath";
    AbilityType[AbilityType["OldArtOfWar"] = 1910] = "OldArtOfWar";
    AbilityType[AbilityType["DeathTouch"] = 1911] = "DeathTouch";
    // Sunbreaker
    AbilityType[AbilityType["HammerSmash"] = 2000] = "HammerSmash";
    AbilityType[AbilityType["Dawnbreaker"] = 2001] = "Dawnbreaker";
    AbilityType[AbilityType["HammerThrow"] = 2002] = "HammerThrow";
    AbilityType[AbilityType["Radiance"] = 2003] = "Radiance";
    AbilityType[AbilityType["DropTheHammer"] = 2004] = "DropTheHammer";
    AbilityType[AbilityType["BrilliantShield"] = 2005] = "BrilliantShield";
    AbilityType[AbilityType["Guardian"] = 2006] = "Guardian";
    AbilityType[AbilityType["EarthShaker"] = 2007] = "EarthShaker";
    AbilityType[AbilityType["ShockShield"] = 2008] = "ShockShield";
    AbilityType[AbilityType["StaggeringBlow"] = 2009] = "StaggeringBlow";
    AbilityType[AbilityType["Starbreaker"] = 2010] = "Starbreaker";
    // Hammer
    AbilityType[AbilityType["ItsHammerTime"] = 2100] = "ItsHammerTime";
    // Thunder Caller
    AbilityType[AbilityType["Bolt"] = 2200] = "Bolt";
    AbilityType[AbilityType["ArcLightning"] = 2201] = "ArcLightning";
    AbilityType[AbilityType["ElectricSlide"] = 2202] = "ElectricSlide";
    AbilityType[AbilityType["Thunderstorm"] = 2203] = "Thunderstorm";
    AbilityType[AbilityType["Downburst"] = 2204] = "Downburst";
    AbilityType[AbilityType["Hail"] = 2205] = "Hail";
    AbilityType[AbilityType["Superbolt"] = 2206] = "Superbolt";
    AbilityType[AbilityType["Halo"] = 2207] = "Halo";
    AbilityType[AbilityType["Wrath"] = 2208] = "Wrath";
    AbilityType[AbilityType["LightningBond"] = 2209] = "LightningBond";
    AbilityType[AbilityType["ThunderCallersStrike"] = 2210] = "ThunderCallersStrike";
    // Druid
    AbilityType[AbilityType["BurstOfFire"] = 2300] = "BurstOfFire";
    AbilityType[AbilityType["Tangle"] = 2301] = "Tangle";
    AbilityType[AbilityType["HealingWater"] = 2302] = "HealingWater";
    AbilityType[AbilityType["Tornado"] = 2303] = "Tornado";
    AbilityType[AbilityType["BriarBulwark"] = 2304] = "BriarBulwark";
    AbilityType[AbilityType["StingingSwarm"] = 2305] = "StingingSwarm";
    AbilityType[AbilityType["IceBlast"] = 2306] = "IceBlast";
    AbilityType[AbilityType["DismissSummoned"] = 2307] = "DismissSummoned";
    AbilityType[AbilityType["NaturesRegeneration"] = 2308] = "NaturesRegeneration";
    AbilityType[AbilityType["Cleansing"] = 2309] = "Cleansing";
    AbilityType[AbilityType["ForestsRejuvenation"] = 2310] = "ForestsRejuvenation";
    AbilityType[AbilityType["SpiritOfTheTreant"] = 2311] = "SpiritOfTheTreant";
    AbilityType[AbilityType["Moonfire"] = 2312] = "Moonfire";
    AbilityType[AbilityType["Wildfire"] = 2313] = "Wildfire";
    // Shade
    AbilityType[AbilityType["ArcaneBlast"] = 2400] = "ArcaneBlast";
    // Necromancer
    AbilityType[AbilityType["DrainLife"] = 2500] = "DrainLife";
    AbilityType[AbilityType["SummonSkeleton"] = 2501] = "SummonSkeleton";
    AbilityType[AbilityType["Fear"] = 2502] = "Fear";
    AbilityType[AbilityType["PoisonCloud"] = 2503] = "PoisonCloud";
    AbilityType[AbilityType["SummonLich"] = 2504] = "SummonLich";
    AbilityType[AbilityType["NullifyMagic"] = 2505] = "NullifyMagic";
    AbilityType[AbilityType["FuneralPyre"] = 2506] = "FuneralPyre";
    AbilityType[AbilityType["SummonSpirit"] = 2507] = "SummonSpirit";
    AbilityType[AbilityType["SpectralShield"] = 2508] = "SpectralShield";
    AbilityType[AbilityType["BestowLife"] = 2509] = "BestowLife";
    AbilityType[AbilityType["EternalDarkness"] = 2510] = "EternalDarkness";
    AbilityType[AbilityType["SummonReaper"] = 2511] = "SummonReaper";
    AbilityType[AbilityType["SeedOfDarkness"] = 2512] = "SeedOfDarkness";
    AbilityType[AbilityType["Ruination"] = 2513] = "Ruination";
    // Gambler
    AbilityType[AbilityType["CardToss"] = 2600] = "CardToss";
    AbilityType[AbilityType["Theft"] = 2601] = "Theft";
    AbilityType[AbilityType["HotStreak"] = 2602] = "HotStreak";
    AbilityType[AbilityType["SweatEm"] = 2603] = "SweatEm";
    AbilityType[AbilityType["Bouncer"] = 2604] = "Bouncer";
    AbilityType[AbilityType["HighStakes"] = 2605] = "HighStakes";
    AbilityType[AbilityType["Rage"] = 2606] = "Rage";
    AbilityType[AbilityType["DirksGambit"] = 2607] = "DirksGambit";
    AbilityType[AbilityType["LoanShark"] = 2608] = "LoanShark";
    AbilityType[AbilityType["BetTheHouse"] = 2609] = "BetTheHouse";
    AbilityType[AbilityType["ArcaneGamble"] = 2610] = "ArcaneGamble";
    // Magician
    AbilityType[AbilityType["MysticBolt"] = 2700] = "MysticBolt";
    AbilityType[AbilityType["SummonersTrickery"] = 2701] = "SummonersTrickery";
    AbilityType[AbilityType["RainOfScimitars"] = 2702] = "RainOfScimitars";
    AbilityType[AbilityType["ConjureSonicCrystal"] = 2703] = "ConjureSonicCrystal";
    AbilityType[AbilityType["ConjureFireCrystal"] = 2704] = "ConjureFireCrystal";
    AbilityType[AbilityType["ConjureFrostCrystal"] = 2705] = "ConjureFrostCrystal";
    AbilityType[AbilityType["ConjureNatureCrystal"] = 2706] = "ConjureNatureCrystal";
    AbilityType[AbilityType["Jolt"] = 2707] = "Jolt";
    AbilityType[AbilityType["AbolishMagic"] = 2708] = "AbolishMagic";
    AbilityType[AbilityType["Burnout"] = 2709] = "Burnout";
    AbilityType[AbilityType["Shockwave"] = 2710] = "Shockwave";
    AbilityType[AbilityType["Twincast"] = 2711] = "Twincast";
    AbilityType[AbilityType["ShadowArmor"] = 2712] = "ShadowArmor";
    AbilityType[AbilityType["EnigmaticCapacity"] = 2713] = "EnigmaticCapacity";
    AbilityType[AbilityType["Aegis"] = 2714] = "Aegis";
    AbilityType[AbilityType["Mirage"] = 2715] = "Mirage";
    AbilityType[AbilityType["PrimordialSymbiosis"] = 2716] = "PrimordialSymbiosis";
    AbilityType[AbilityType["SummonGreaterElementalServant"] = 2717] = "SummonGreaterElementalServant";
    // Buddy the Penguin
    AbilityType[AbilityType["StayFrosty"] = 2800] = "StayFrosty";
    AbilityType[AbilityType["CruelWinter"] = 2801] = "CruelWinter";
    AbilityType[AbilityType["Frostshield"] = 2802] = "Frostshield";
    AbilityType[AbilityType["IceLance"] = 2803] = "IceLance";
    AbilityType[AbilityType["DigIn"] = 2804] = "DigIn";
    AbilityType[AbilityType["Frostward"] = 2805] = "Frostward";
    AbilityType[AbilityType["Frostfall"] = 2806] = "Frostfall";
    AbilityType[AbilityType["PenguinPummel"] = 2807] = "PenguinPummel";
    AbilityType[AbilityType["WallOfFrost"] = 2808] = "WallOfFrost";
    AbilityType[AbilityType["IceSpikeShield"] = 2809] = "IceSpikeShield";
    AbilityType[AbilityType["WarmingPresence"] = 2810] = "WarmingPresence";
    AbilityType[AbilityType["BlessingOfFrost"] = 2811] = "BlessingOfFrost";
    AbilityType[AbilityType["CallOfTheSnowman"] = 2812] = "CallOfTheSnowman";
    // Bard
    AbilityType[AbilityType["MagsMenacingMelody"] = 2900] = "MagsMenacingMelody";
    AbilityType[AbilityType["ALuckyLamentation"] = 2901] = "ALuckyLamentation";
    AbilityType[AbilityType["NorthsElegy"] = 2902] = "NorthsElegy";
    AbilityType[AbilityType["SongOfMidnight"] = 2903] = "SongOfMidnight";
    AbilityType[AbilityType["BigsBoastfulBellow"] = 2904] = "BigsBoastfulBellow";
    AbilityType[AbilityType["ShaunisShanty"] = 2905] = "ShaunisShanty";
    AbilityType[AbilityType["AlaresasAppallingSquall"] = 2906] = "AlaresasAppallingSquall";
    AbilityType[AbilityType["PrestigesPerfectPiece"] = 2907] = "PrestigesPerfectPiece";
    AbilityType[AbilityType["NjordsLullaby"] = 2908] = "NjordsLullaby";
    AbilityType[AbilityType["HealingRhythm"] = 2909] = "HealingRhythm";
    AbilityType[AbilityType["SonorasShield"] = 2910] = "SonorasShield";
    AbilityType[AbilityType["DirksDevastatingDitty"] = 2911] = "DirksDevastatingDitty";
    AbilityType[AbilityType["NearsMissingNote"] = 2912] = "NearsMissingNote";
    AbilityType[AbilityType["HishasHarmony"] = 2913] = "HishasHarmony";
    AbilityType[AbilityType["CantataOfTaluvias"] = 2914] = "CantataOfTaluvias";
    AbilityType[AbilityType["HymnOfHeimdall"] = 2915] = "HymnOfHeimdall";
    AbilityType[AbilityType["TauntingShout"] = 2916] = "TauntingShout";
    // Time keeper
    AbilityType[AbilityType["Continuance"] = 3000] = "Continuance";
    AbilityType[AbilityType["Diverge"] = 3001] = "Diverge";
    AbilityType[AbilityType["Decompose"] = 3002] = "Decompose";
    AbilityType[AbilityType["Reconstruct"] = 3003] = "Reconstruct";
    AbilityType[AbilityType["Replay"] = 3004] = "Replay";
    AbilityType[AbilityType["Evolve"] = 3005] = "Evolve";
    AbilityType[AbilityType["Calculus"] = 3006] = "Calculus";
    AbilityType[AbilityType["Stasis"] = 3007] = "Stasis";
    AbilityType[AbilityType["Haste"] = 3008] = "Haste";
    AbilityType[AbilityType["Impede"] = 3009] = "Impede";
    AbilityType[AbilityType["Shape"] = 3010] = "Shape";
    AbilityType[AbilityType["NaN"] = 3011] = "NaN";
    /********************
     * Companions/Pets  *
     ********************/
    // Cat
    AbilityType[AbilityType["Bite"] = 10000] = "Bite";
    AbilityType[AbilityType["Claw"] = 10001] = "Claw";
    AbilityType[AbilityType["Roar"] = 10002] = "Roar";
    AbilityType[AbilityType["Swipe"] = 10003] = "Swipe";
    AbilityType[AbilityType["Pounce"] = 10004] = "Pounce";
    // Soul
    AbilityType[AbilityType["Abracadabra"] = 10100] = "Abracadabra";
    // Archangel
    AbilityType[AbilityType["UnholyFire"] = 10200] = "UnholyFire";
    // Necromancer's Pet Abilities
    AbilityType[AbilityType["SkeletalSlice"] = 10300] = "SkeletalSlice";
    AbilityType[AbilityType["Taunt"] = 10301] = "Taunt";
    AbilityType[AbilityType["TouchOfTheDead"] = 10302] = "TouchOfTheDead";
    AbilityType[AbilityType["Decay"] = 10303] = "Decay";
    AbilityType[AbilityType["Reap"] = 10304] = "Reap";
    // Gambler's Pet Abilities
    AbilityType[AbilityType["Backhand"] = 10400] = "Backhand";
    // Snowman
    AbilityType[AbilityType["IcicleStorm"] = 10500] = "IcicleStorm";
    // Greater Elemental Servant
    AbilityType[AbilityType["ElementalBlast"] = 10600] = "ElementalBlast";
    AbilityType[AbilityType["ElementalShockFire"] = 10601] = "ElementalShockFire";
    AbilityType[AbilityType["ElementalShockFrost"] = 10602] = "ElementalShockFrost";
    AbilityType[AbilityType["ElementalShockNature"] = 10603] = "ElementalShockNature";
    AbilityType[AbilityType["ElementalShockSonic"] = 10604] = "ElementalShockSonic";
    // NPC Abilities
    // Dock Worker
    AbilityType[AbilityType["Pummel"] = 11000] = "Pummel";
    // Circus Monkey
    AbilityType[AbilityType["ThrowBanana"] = 11001] = "ThrowBanana";
    // Werewolf
    AbilityType[AbilityType["VengefulHowl"] = 11002] = "VengefulHowl";
    AbilityType[AbilityType["Bloodletting"] = 11003] = "Bloodletting";
    // Mountain Giant
    AbilityType[AbilityType["GiantsCrush"] = 11004] = "GiantsCrush";
    // Fire Elemental
    AbilityType[AbilityType["ElementalBlessingFire"] = 11005] = "ElementalBlessingFire";
    // Frost Elemental
    AbilityType[AbilityType["ElementalBlessingFrost"] = 11006] = "ElementalBlessingFrost";
    // Earth Elemental
    AbilityType[AbilityType["ElementalBlessingEarth"] = 11007] = "ElementalBlessingEarth";
    // Energized Elemental
    AbilityType[AbilityType["ElementalBlessingLightning"] = 11008] = "ElementalBlessingLightning";
    // Basilisk Snake
    AbilityType[AbilityType["DeadlyIncision"] = 11009] = "DeadlyIncision";
    // Chicken
    AbilityType[AbilityType["Peck"] = 11010] = "Peck";
    // Anomaly
    AbilityType[AbilityType["EnergyField"] = 11011] = "EnergyField";
    // Armored Mammoth
    AbilityType[AbilityType["Gore"] = 11012] = "Gore";
    // NPC
    AbilityType[AbilityType["Charm"] = 11013] = "Charm";
    AbilityType[AbilityType["AncientDecay"] = 11014] = "AncientDecay";
    AbilityType[AbilityType["EmperorsRegeneration"] = 11015] = "EmperorsRegeneration";
    AbilityType[AbilityType["EmperorsWeakness"] = 11016] = "EmperorsWeakness";
    AbilityType[AbilityType["EmperorsSlice"] = 11017] = "EmperorsSlice";
    AbilityType[AbilityType["EmperorsSwiftness"] = 11018] = "EmperorsSwiftness";
    AbilityType[AbilityType["AncientElvenSlice"] = 11019] = "AncientElvenSlice";
    AbilityType[AbilityType["Stun"] = 11020] = "Stun";
    AbilityType[AbilityType["OldOrcishWays"] = 11021] = "OldOrcishWays";
    AbilityType[AbilityType["DaVu"] = 11022] = "DaVu";
    AbilityType[AbilityType["HitsLikeAMackTrk"] = 11023] = "HitsLikeAMackTrk";
    AbilityType[AbilityType["SoulHarvest"] = 11024] = "SoulHarvest";
    AbilityType[AbilityType["Plague"] = 11025] = "Plague";
    AbilityType[AbilityType["WintersChill"] = 11026] = "WintersChill";
    AbilityType[AbilityType["SwordPlunge"] = 11027] = "SwordPlunge";
    AbilityType[AbilityType["Shout"] = 11028] = "Shout";
    AbilityType[AbilityType["Bounce"] = 11029] = "Bounce";
    AbilityType[AbilityType["ClownSlap"] = 11030] = "ClownSlap";
    AbilityType[AbilityType["TheLionInMe"] = 11031] = "TheLionInMe";
    AbilityType[AbilityType["Charge"] = 11032] = "Charge";
    AbilityType[AbilityType["CrushedByAnElephant"] = 11033] = "CrushedByAnElephant";
    AbilityType[AbilityType["RighteousIndignation"] = 11034] = "RighteousIndignation";
    AbilityType[AbilityType["HolyWater"] = 11035] = "HolyWater";
    AbilityType[AbilityType["Malice"] = 11036] = "Malice";
    AbilityType[AbilityType["Reinforcements"] = 11037] = "Reinforcements";
    AbilityType[AbilityType["TheodoresSmite"] = 11038] = "TheodoresSmite";
    AbilityType[AbilityType["Launch"] = 11039] = "Launch";
    AbilityType[AbilityType["ReflectiveCurse"] = 11040] = "ReflectiveCurse";
    AbilityType[AbilityType["Trample"] = 11041] = "Trample";
    AbilityType[AbilityType["ConstrictingVolley"] = 11042] = "ConstrictingVolley";
    AbilityType[AbilityType["ReflexShot"] = 11043] = "ReflexShot";
    AbilityType[AbilityType["QuickSlice"] = 11044] = "QuickSlice";
    AbilityType[AbilityType["ThrowMagneticBomb"] = 11045] = "ThrowMagneticBomb";
    AbilityType[AbilityType["Heat"] = 11046] = "Heat";
    AbilityType[AbilityType["ThirtyPounder"] = 11047] = "ThirtyPounder";
    AbilityType[AbilityType["BurningBreath"] = 11048] = "BurningBreath";
    AbilityType[AbilityType["ColossalSmash"] = 11049] = "ColossalSmash";
    AbilityType[AbilityType["MeteorFist"] = 11050] = "MeteorFist";
    // War Wolf
    AbilityType[AbilityType["ViciousClaws"] = 11051] = "ViciousClaws";
    AbilityType[AbilityType["WarWolfsSwipe"] = 11052] = "WarWolfsSwipe";
    AbilityType[AbilityType["DragonWhelp_Swipe"] = 11053] = "DragonWhelp_Swipe";
    AbilityType[AbilityType["DragonWhelp_FirePuff"] = 11054] = "DragonWhelp_FirePuff";
    // Cyndine
    AbilityType[AbilityType["CyndinesSoulHarvest"] = 12000] = "CyndinesSoulHarvest";
    AbilityType[AbilityType["BloodyClaws"] = 12001] = "BloodyClaws";
    AbilityType[AbilityType["Bloodlust"] = 12002] = "Bloodlust";
    AbilityType[AbilityType["DampeningCurse"] = 12003] = "DampeningCurse";
    AbilityType[AbilityType["BloodSignet"] = 12004] = "BloodSignet";
    AbilityType[AbilityType["BloodBeam"] = 12005] = "BloodBeam";
    // cinder drake
    AbilityType[AbilityType["FieryEnding"] = 12006] = "FieryEnding";
    AbilityType[AbilityType["HiveMother"] = 12007] = "HiveMother";
    // Cerberus
    AbilityType[AbilityType["HellsFury"] = 12010] = "HellsFury";
    AbilityType[AbilityType["Cerberus_MeltArmor"] = 12011] = "Cerberus_MeltArmor";
    AbilityType[AbilityType["HellsRetribution"] = 12012] = "HellsRetribution";
    // Aspect of Kaboom
    AbilityType[AbilityType["ElementalDischarge"] = 13000] = "ElementalDischarge";
    AbilityType[AbilityType["VoidZone"] = 13002] = "VoidZone";
    AbilityType[AbilityType["ElementalOverload"] = 13004] = "ElementalOverload";
    AbilityType[AbilityType["Stormfall"] = 13005] = "Stormfall";
    // Headless Horseman
    AbilityType[AbilityType["HorsemansInferno"] = 14000] = "HorsemansInferno";
    AbilityType[AbilityType["Boo"] = 14001] = "Boo";
    AbilityType[AbilityType["UndeadResolve"] = 14002] = "UndeadResolve";
    // Ooze
    AbilityType[AbilityType["Corrode"] = 14003] = "Corrode";
    // Bears???
    AbilityType[AbilityType["ChasedByBears"] = 14004] = "ChasedByBears";
    // Call of the Wild: Dragon Whelp
    AbilityType[AbilityType["COW_DragonWhelp_Flare"] = 14005] = "COW_DragonWhelp_Flare";
    AbilityType[AbilityType["COW_DragonWhelp_Cauterize"] = 14006] = "COW_DragonWhelp_Cauterize";
    AbilityType[AbilityType["COW_DragonWhelp_Scorch"] = 14007] = "COW_DragonWhelp_Scorch";
    AbilityType[AbilityType["COW_DragonWhelp_Kindle"] = 14008] = "COW_DragonWhelp_Kindle";
    AbilityType[AbilityType["COW_DragonWhelp_FireBreath"] = 14009] = "COW_DragonWhelp_FireBreath";
    // Coldlight Walker
    AbilityType[AbilityType["ColdlightVortex"] = 14010] = "ColdlightVortex";
    AbilityType[AbilityType["Coldbolt"] = 14011] = "Coldbolt";
    AbilityType[AbilityType["ChillyEmpowerment"] = 14012] = "ChillyEmpowerment";
})(AbilityType = exports.AbilityType || (exports.AbilityType = {}));
